import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { globalConst } from 'modules/global';
import { useDownloadCertificate } from 'modules/private-universities';

interface IProps {
  id?: number;
  type?: string;
  ball?: number;
  passingBall?: number;
  createdAt?: number;
}

const ResultsCard: React.FC<IProps> = ({ id, type, ball, createdAt, passingBall }) => {
  const t = useTranslations();
  const { mutate: downloadCertificate, isLoading: isDownloading } = useDownloadCertificate();

  const onDownload = (e: any) => {
    e.stopPropagation();
    downloadCertificate(id);
  };

  return (
    <Link href={`${globalConst.pageNames.RESULTS}/${id}`} className="rounded-2xl bg-white p-4 shadow">
      <div className="flex items-center justify-between">
        <div className="rounded-sm border-none bg-green-50 px-2 text-sm text-green-500">{type}</div>
        {passingBall != null && ball != null && passingBall <= ball && (
          <div onClick={onDownload} className="rounded-sm border border-indigo-600 px-2 text-sm text-indigo-500">
            {isDownloading && <LoadingOutlined />} {t('sertifikatni_korish')}
          </div>
        )}
      </div>
      <div className="mt-3 rounded-lg bg-gray-50 p-2 text-sm">
        <div className="mb-4 flex items-center justify-between text-xs">
          <div className="text-gray-500">{t('profile.right_side.test_varianti_raqami')}</div>
          {/* eslint-disable-next-line i18next/no-literal-string */}
          <div className="font-medium">№{id}</div>
        </div>
        <div className="flex items-center justify-between text-xs">
          <div className="text-gray-500">{t('profile.right_side.toplangan_ball')}</div>
          <div className="font-medium text-green-500">
            {ball || 0} {t('ball')}
          </div>
        </div>
      </div>

      <div className="mt-3 text-xs text-gray-500">
        {dayjs(createdAt).format('DD.MM.YYYY HH:mm')}
        {/* {dayjs.unix(created_at).format("DD.MM.YYYY HH:mm")} */}
      </div>
    </Link>
  );
};

export default ResultsCard;
